// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"e03dcd40","354":"6b1038d5","838":"78624752"}[chunkId] + ".js";
};